const createCardTemplate = view =>
    view.state.schema.nodes.card.create({}, [
      view.state.schema.nodes.card_content.create({}, [
        view.state.schema.nodes.card_content_header.create({},
            view.state.schema.nodes.paragraph.create({},
                view.state.schema.text('${key}', view.state.schema.marks.link.create({
                  href: '${swf:taskUrl}',
                })))),
        view.state.schema.nodes.card_content_meta.create({},
            view.state.schema.nodes.paragraph.create({},
                view.state.schema.text('${type} - ${priority}'))),
        view.state.schema.nodes.card_content_description.create({},
            view.state.schema.nodes.paragraph.create({},
                view.state.schema.text('${summary}'))),
      ]),
      view.state.schema.nodes.card_content_extra.create({}, [
        view.state.schema.nodes.paragraph.create({},
            [
              view.state.schema.text('${swf:createdBy.fullName} - '),
              view.state.schema.text('${swf:createdOn}',
                  view.state.schema.marks.relative_time.create({
                    datetime: '${swf:createdOn}'
                  })),
            ]),
      ]),
    ]);

export const tasksBoardNodes = view =>
    view.state.schema.nodes.grid.createAndFill({}, [
          view.state.schema.nodes.grid_column.createAndFill({
            width: 4,
            color: 'grey',
            filter: `? (@.status == "Open")`,
            inputParameters: {
              'status': 'Open',
            },
          }, [
            view.state.schema.nodes.paragraph.create({},
                [
                  view.state.schema.text('Backlog ',
                      view.state.schema.marks.strong.create()),
                  view.state.schema.nodes.emoji.createAndFill({
                    src: '/images/emoji/1f5c3.svg',
                    alt: '🗃️',
                  })
                ]
            ),
            createCardTemplate(view),
          ]),
          view.state.schema.nodes.grid_column.createAndFill({
            width: 4,
            color: 'blue',
            filter: `? (@.status == "In Progress")`,
            inputParameters: {
              'status': 'In Progress',
            },
          }, [
            view.state.schema.nodes.paragraph.create({},
                [
                  view.state.schema.text('In Progress ',
                      view.state.schema.marks.strong.create()),
                  view.state.schema.nodes.emoji.createAndFill({
                    src: '/images/emoji/1f685.svg',
                    alt: '🚅',
                  })
                ]
            ),
            createCardTemplate(view),
          ]),
          view.state.schema.nodes.grid_column.createAndFill({
            width: 4,
            color: 'yellow',
            filter: `? (@.status == "Review")`,
            inputParameters: {
              'status': 'Review',
            },
          }, [
            view.state.schema.nodes.paragraph.create({},
                [
                  view.state.schema.text('Review ',
                      view.state.schema.marks.strong.create(),
                  ),
                  view.state.schema.nodes.emoji.createAndFill({
                    src: '/images/emoji/231b.svg',
                    alt: '⌛',
                  }),
                ],
            ),
            createCardTemplate(view),
          ]),
          view.state.schema.nodes.grid_column.createAndFill({
            width: 4,
            color: 'purple',
            filter: `? (@.status == "Done")`,
            inputParameters: {
              'status': 'Done',
            },
          }, [
            view.state.schema.nodes.paragraph.create({},
                [
                  view.state.schema.text('Done ',
                      view.state.schema.marks.strong.create()),
                  view.state.schema.nodes.emoji.createAndFill({
                    src: '/images/emoji/2705.svg',
                    alt: '✅',
                  }),
                ],
            ),
            createCardTemplate(view),
          ]),
        ],
    );